/**
 * Fallback temporal en el front (deuda técnica backend): mapea `chatbotId` → parámetros del
 * planner (tenant/subdomain + ciudad de geocoding) en el front, para que el
 * embed necesite SOLO `?id=<chatbotId>` y no `?city=`/`?tenant=`.
 *
 * Quitar cuando el backend exponga estos campos por chatbotId en
 * `get-cicerone-data-chat` (ver sección 7b del plan). Los query params
 * `?city=`/`?tenant=` siguen valiendo como override puntual.
 */
export interface EmbedPlannerParams {
  /** Slug de tenant que usa el backend de rutas (subDomain). */
  tenant: string;
  /** Ciudad/región para el geocoding del punto de partida. */
  city: string;
}

export const EMBED_PLANNER_PARAMS: Record<string, EmbedPlannerParams> = {
  // Visit Madrid (chatbot "Sol", cliente 130)
  '133': { tenant: 'mirutavisitmadrid', city: 'Madrid' },
};

export function resolveEmbedParams(chatbotId: string | null | undefined): EmbedPlannerParams | null {
  if (!chatbotId) return null;
  return EMBED_PLANNER_PARAMS[String(chatbotId)] ?? null;
}
